import axios, { AxiosInstance } from 'axios';
import { BASE_API_URL } from '../app/constants';

export const apiHttpService: AxiosInstance = axios.create({
  baseURL: BASE_API_URL,
});
